export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.server) {
    return
  }

  const currentShop = useCurrentShop()

  const locale = currentShop.value.locale

  const lang = locale.split('_')[0]

  nuxtApp.hook('vue:setup', () => {
    useHead({
      htmlAttrs: {
        lang,
      },
    })
  })
})
